export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/generation.worker.cf047735.worker.js");
}
